export default __webpack_public_path__ + "static/media/pandazenLogo.d6c11305.png";